import React, { useCallback } from "react";
import PropTypes from "prop-types";
import StockList from "components/StockList";
import styles from "./SavedListPage.module.css";
import { useTranslation } from "react-i18next";
import BackArrow from "../../assets/Back_Arrow.svg";
import { useHistory } from "react-router-dom";
import {
  useListItems,
  useRemoveListItem,
} from "../../hooks/useLists";

export function SavedListPage({ listId, listName, listType, onBack }) {
  const { t } = useTranslation();
  const { data: stockInfo = [], isLoading } = useListItems(listId);
  const removeListItem = useRemoveListItem();

  const isPurchasedItemsList =
    String(listType || "").toUpperCase() === "PURCHASED_ITEMS";
  const isSavedForLaterList =
    String(listType || "").toUpperCase() === "SAVED_FOR_LATER";

  const handleRemoveItem = useCallback(
    (listProductId) => {
      if (listId != null && listProductId != null) {
        removeListItem.mutate({ listId, listProductId });
      }
    },
    [listId, removeListItem]
  );

  const history = useHistory();
  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    history.push("/my-lists");
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className={styles.page}>
      <div className={styles.backWrap}>
        <button className={styles.backNav} onClick={handleBack}>
          <img src={BackArrow} alt="Back" className={styles.backIcon} />
          <span className={styles.backLabel}>{t("My Lists")}</span>
        </button>
        {listName && <span className={styles.listTitle}>{listName}</span>}
      </div>
      {stockInfo.length > 0 ? (
        <>
          <div className={styles.container}>
            <div className={styles.listSpacer} />
            <StockList
              stockInfo={stockInfo}
              pageFrom={t("My List")}
              listId={listId}
              isList={true}
              onDelete={isPurchasedItemsList ? undefined : handleRemoveItem}
              showNote
              forceListLayout={isPurchasedItemsList}
              removeFromListOnAddToCart={isSavedForLaterList}
            />
          </div>
        </>
      ) : (
        <div>
          <p className={styles.empty}>
            {t("There are no items in this list.")}
          </p>
        </div>
      )}
    </div>
  );
}

SavedListPage.propTypes = {
  listId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  listName: PropTypes.string,
  listType: PropTypes.string,
  onBack: PropTypes.func,
};

export default SavedListPage;
